import React from "react";
import "./numpad.component.scss";
import { Numpad, NumpadButton } from "@merrie/nmbrs-api";
import { NumpadButtonComponent } from "../numpad-button/numpad-button.component";

export interface INumpadProperties {
  numpad: Numpad;
  onNumpadButtonClick: (button: NumpadButton) => void;
}

export const NumpadComponent: React.FC<INumpadProperties> = ({
  numpad,
  onNumpadButtonClick,
}) => {
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const numpadButtonBlur = () => {
    setActiveIndex(-1);
  };

  const numpadButtonFocus = (i: number) => {
    setActiveIndex(i);
  };

  onKeyDown("ArrowDown", () => {
    setActiveIndex((activeIndex) => {
      const index = activeIndex + numpad.columns;
      return index > numpad.buttons.length - 1 || activeIndex === -1
        ? activeIndex
        : index;
    });
  });

  onKeyDown("ArrowLeft", () => {
    setActiveIndex((activeIndex) => {
      const index = activeIndex - 1;
      const row = Math.ceil((activeIndex + 1) / numpad.columns);

      return activeIndex === (row - 1) * numpad.columns || activeIndex === -1
        ? activeIndex
        : index;
    });
  });

  onKeyDown("ArrowRight", () => {
    setActiveIndex((activeIndex) => {
      const index = activeIndex + 1;
      const row = Math.ceil((activeIndex + 1) / numpad.columns);

      return index === row * numpad.columns || activeIndex === -1
        ? activeIndex
        : index;
    });
  });

  onKeyDown("ArrowUp", () => {
    setActiveIndex((activeIndex) => {
      const index = activeIndex - numpad.columns;
      return index < 0 || activeIndex === -1 ? activeIndex : index;
    });
  });

  numpad.buttons.forEach((button, index) => {
    if (button.keys && button.keys.length > 0) {
      button.keys.forEach((key) => {
        onKeyDown(key, (event) => {
          event.preventDefault();
          const buttons = document.getElementsByClassName("numpad-button");
          if (buttons) {
            const clearButton = buttons[index] as HTMLButtonElement;
            clearButton.classList.add("active");
            setTimeout(() => {
              clearButton.classList.remove("active");
            }, 100);
            clearButton.click();
          }
        });
      });
    }
  });

  return (
    <div className={`numpad`}>
      {numpad.buttons.map((button, index) => (
        <div className={"numpad-button-container"} key={index}>
          <NumpadButtonComponent
            button={button}
            isFocused={activeIndex === index}
            onClick={() => onNumpadButtonClick(button)}
            onFocus={() => numpadButtonFocus(index)}
            onBlur={() => numpadButtonBlur()}
          />
        </div>
      ))}
    </div>
  );
};

export default function onKeyDown(
  key: string,
  action: (e: KeyboardEvent) => void
) {
  React.useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      if (e.key === key && !e.ctrlKey) action(e);
    };

    window.addEventListener("keydown", onKeydown);
    return () => window.removeEventListener("keydown", onKeydown);
  }, []);
}
